<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 14,
      height: 14,
      color: 'currentColor',
      viewBoxValue: `0 0 14 14`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.00061 0C3.13438 0 0 3.13438 0 6.99939C0 10.8644 3.13438 14 7.00061 14C10.8668 14 14 10.8656 14 6.99939C14 3.13317 10.8656 0 7.00061 0ZM10.9898 6.56954L7.39149 10.325C7.23563 10.4967 7.00061 10.4967 6.85935 10.3566L3.21353 6.58659C3.08811 6.44533 3.08811 6.21153 3.21353 6.08611L5.23128 4.02087C5.37253 3.87962 5.60633 3.87962 5.74759 4.02087L6.84231 5.17892C6.98356 5.33478 7.23319 5.32017 7.37445 5.16309L8.39123 4.02087C8.53249 3.86501 8.76629 3.86501 8.92337 4.00504L10.9886 6.07028C11.1299 6.21153 11.1299 6.43072 10.9886 6.57076L10.9898 6.56954Z"
      fill="currentColor"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
